import React from "react";
import TradeTron from "./TradeTron/TradeTron";
import FoxTrader from "./FoxTrader/FoxTrader";
import CockPit from "./CockPit/CockPit";
import "./OurTools.css";
function OurTools(){
    return(
        <>
        <div className="ourtools_page">
            <FoxTrader />
            <TradeTron />
            <CockPit />
            </div>
        </>
    );
}
export default OurTools;